/**
 * ErrorBoundary.jsx — GRANULLO_PRODUCTION_HARDENING
 *
 * Global error boundary for graceful failure handling.
 * Catches React render errors and shows recovery UI.
 */
import React from 'react';

const EDITORIAL_RED = '#CD2200';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Granullo ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--g-bg, #0a0a0a)', color: 'var(--g-text, #e0e0e0)' }} data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="mb-6">
              <svg width="32" height="32" viewBox="0 0 32 32" className="mx-auto">
                <circle cx="16" cy="16" r="14" fill="none" stroke={EDITORIAL_RED} strokeWidth="1.5" opacity="0.4" />
                <line x1="11" y1="11" x2="21" y2="21" stroke={EDITORIAL_RED} strokeWidth="1.5" strokeLinecap="round" />
                <line x1="21" y1="11" x2="11" y2="21" stroke={EDITORIAL_RED} strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <h1 className="text-lg font-semibold mb-2" style={{ fontFamily: '"Inter Tight", sans-serif', letterSpacing: '-0.02em' }}>
              Something went wrong
            </h1>
            <p className="text-sm mb-6" style={{ color: 'var(--g-text-secondary, #888)' }}>
              An unexpected error occurred. This has been logged for review.
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}
              className="px-5 py-2.5 rounded-xl text-sm font-medium transition-all"
              style={{ background: `${EDITORIAL_RED}15`, border: `1px solid ${EDITORIAL_RED}30`, color: EDITORIAL_RED }}
              data-testid="error-recovery-btn"
            >
              Return to Granullo
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
